import { Box } from '@mui/material'

export const VoteIcon = (props) => {
  return (
    <Box {...props}>
      <img src='/vote.svg' />
    </Box>
  )
}
